import {License, licenseSchema} from "./License";
import {useTranslation} from "react-i18next";
import React from "react";
import {makeRequired} from "../../../shared/components/forms/formUtils";
import {Grid} from "@mui/material";
import {Application} from "../Application";
import {MuiRhfNumberField} from "../../../shared/components/forms/MuiRhfNumberField";

export function UserQuotaLicenseForm(props: {
  application: Application,
  license: License,
  readOnly: boolean,
}) {
  const {t} = useTranslation();

  const stdFieldProps = {
    variant: "outlined" as "outlined",
    disabled: props.readOnly,
    InputLabelProps: {
      shrink: true
    }
  }
  const required = makeRequired(licenseSchema(t));
  return (
    <Grid item={true} xs={12} md={7} lg={8}>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={10} lg={5}>
          <MuiRhfNumberField name={"userQuotaLicense.quota"}
                             label={t('License.userQuotaLicense.quota')}
                             fullWidth={true}
                             required={required.userQuotaLicense.quota}
                             {...stdFieldProps}
          />
        </Grid>
        <Grid item={true} xs={10} lg={5}>
          <MuiRhfNumberField name={"userQuotaLicense.usage"}
                             label={t('License.userQuotaLicense.usage')}
                             fullWidth={true}
                             {...stdFieldProps}
                             disabled={true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
